import axios from "axios";
import React, { useState } from "react";
import SmallLoader from "@shared/components/Atoms/Loading/SmallLoading";
import { APP_NAME } from "@shared/util/brand";

const ForgotPassword = () => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleForgotSubmit = async (e) => {
    e.preventDefault();
    try {
      setError("");
      setLoading(true);
      const button = document.querySelector("#forgot_btn");
      button.textContent = "Sending Reset Link ...";
      button.disabled = true;
      const res = await axios.post(
        `${import.meta.env.VITE_API_URL}/auth/request-reset`,
        {
          email,
        }
      );
      // console.log({ res })
      if (res?.data) {
        setStep(2);
      }
    } catch (err) {
      console.error(err);
      setError(
        err?.response?.data?.error || "An error occurred. Please try again."
      );
    } finally {
      setLoading(false);
      const button2 = document.querySelector("#forgot_btn");
      button2.textContent = "Send Reset Link";
      button2.disabled = false;
    }
  };
  const handleTryAgain = async () => {
    setEmail("");
    goToStep(1);
    // try {
    //   setError("");
    //   setLoading(true);
    //   const res = await axios.post(
    //     `${import.meta.env.VITE_API_URL}/auth/request-reset`,
    //     {
    //       email,
    //     }
    //   );
    //   // console.log({ res })
    //   if (res?.data) {
    //     setStep(2);
    //   }
    // } catch (err) {
    //   console.error(err);
    //   setError(
    //     err?.response?.data?.error || "An error occurred. Please try again."
    //   );
    // } finally {
    //   setLoading(false);
    // }
  };

  const goToStep = (index) => setStep(index);

  return (
    <div className="min-h-screen flex flex-col items-center bg-gradient-to-br from-[#2563EB] via-[#1D4ED8] to-[#1E3A8A] p-5">
      <div className="text-white text-3xl font-semibold mt-5 mb-10">
        {APP_NAME}
      </div>

      <div className="bg-white rounded-2xl p-10 w-full max-w-md shadow-xl text-center">
        {/* Step 1 */}
        {step === 1 && (
          <div>
            <h1 className="text-2xl font-semibold text-[#1E3A8A] mb-2">
              Forgot Password?
            </h1>
            <p className="text-gray-600 mb-6">
              Enter your email to reset your password
            </p>
            <form onSubmit={handleForgotSubmit} className="text-left">
              <label className="block text-[#1E3A8A] font-medium mb-2">
                Email Address
              </label>
              <input
                type="email"
                className="w-full p-4 rounded-xl bg-gray-100 border-2 border-gray-200 focus:border-blue-500 focus:bg-white transition mb-6"
                placeholder="your@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <div className="my-4">
                {error && (
                  <div className="bg-red-100 text-red-700 px-4 py-2 rounded text-sm text-center mb-2">
                    {error}
                  </div>
                )}
                {loading && <SmallLoader />}
              </div>
              <button
                type="submit"
                id="forgot_btn"
                className="w-full py-4 bg-gradient-to-br from-[#2563EB] via-[#1D4ED8] to-[#1E3A8A] text-white font-semibold rounded-xl hover:shadow-lg transition mb-4"
              >
                Send Reset Link
              </button>
            </form>
            <button
              className="text-blue-500 hover:underline text-sm"
              onClick={() => { window.location.href = "/login"; }}
            >
              Back to Sign In
            </button>
          </div>
        )}

        {/* Step 2 */}
        {step === 2 && (
          <div>
            <div className="w-20 h-20 mx-auto rounded-full bg-green-600 text-white flex items-center justify-center text-3xl mb-6">
              ✉️
            </div>
            <h1 className="text-2xl font-semibold text-[#1E3A8A] mb-2">
              Check Your Email
            </h1>
            <p className="text-gray-600 mb-4">Reset link sent successfully</p>
            <p className="text-gray-600 mb-4">
              We've sent a reset link to: <br />
              <span className="text-[#1E3A8A] font-semibold">{email}</span>
            </p>
            <p className="text-gray-600 mb-6">
              Click the link in your email to reset your password. If you don't
              see it, check your spam folder.
            </p>
            <div className="my-4">
              {error && (
                <div className="bg-red-100 text-red-700 px-4 py-2 rounded text-sm text-center mb-2">
                  {error}
                </div>
              )}
              {loading && <SmallLoader />}
            </div>
            <div className="text-sm text-gray-600 bg-gray-100 p-4 text-left rounded-lg mb-6">
              <strong>Can't find the email?</strong>
              <ul className="list-disc ml-6 mt-2">
                <li>Check your spam or junk mail folder</li>
                <li>Make sure you entered the correct email address</li>
                <li>Wait a few minutes - emails can sometimes be delayed</li>
                <li>Add videobrief.ai to your email contacts</li>
              </ul>
            </div>
            <button
              className="text-gray-600 font-semibold rounded-xl mb-4"
              onClick={() => handleTryAgain()}
            >
              Try Again
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
